import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CustomSpecInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let clonedReq = request;

    // Spécialisation pour les requêtes PATCH
    if (request.method === 'PATCH') {
      clonedReq = request.clone({
        headers: request.headers.set('Content-Type', 'application/merge-patch+json'),
      });
    }

    // Transmettre la requête modifiée au prochain intercepteur ou au backend
    return next.handle(clonedReq);
  }
}